<template>
  <div class="captcha-container">
    <canvas ref="canvas" :width="width" :height="height"></canvas>
    <button type="button" @click="regenerate">↻</button>
  </div>
</template>

<script>
export default {
  name: 'Captcha',
  props: {
    length: { type: Number, default: 5 },
    width: { type: Number, default: 120 },
    height: { type: Number, default: 40 },
    fontSize: { type: Number, default: 28 },
    fontFamily: { type: String, default: 'monospace' },
    fontColor: { type: String, default: '#333' },
  },
  data() {
    return {
      captchaText: '',
      noiseLines: [],
    };
  },
  computed: {},
  methods: {
    generateText() {
      const chars = 'ABCDEFGHJKLMNPQRSTUVWXYZ23456789';
      let text = '';
      for (let i = 0; i < this.length; i++) {
        text += chars.charAt(Math.floor(Math.random() * chars.length));
      }
      return text;
    },
    generateNoise() {
      const lines = [];
      for (let i = 0; i < 4; i++) {
        lines.push({
          x1: Math.random() * this.width,
          y1: Math.random() * this.height,
          x2: Math.random() * this.width,
          y2: Math.random() * this.height,
          color: '#'+Math.floor(Math.random()*16777215).toString(16),
          width: 1 + Math.random() * 2,
        });
      }
      return lines;
    },
    drawCaptcha() {
      const canvas = this.$refs.canvas;
      if (!canvas) return;
      const ctx = canvas.getContext('2d');
      ctx.clearRect(0, 0, this.width, this.height);
      // Draw background
      ctx.fillStyle = '#f9f9f9';
      ctx.fillRect(0, 0, this.width, this.height);
      // Draw noise lines
      this.noiseLines.forEach(line => {
        ctx.beginPath();
        ctx.moveTo(line.x1, line.y1);
        ctx.lineTo(line.x2, line.y2);
        ctx.strokeStyle = line.color;
        ctx.lineWidth = line.width;
        ctx.stroke();
      });
      // Draw distorted text
      ctx.save();
      const angle = (Math.random() - 0.5) * 0.4; // -0.2 to 0.2 radians
      ctx.translate(this.width / 2, this.height / 2);
      ctx.rotate(angle);
      ctx.font = `${this.fontSize}px ${this.fontFamily}`;
      ctx.textAlign = 'center';
      ctx.textBaseline = 'middle';
      ctx.fillStyle = this.fontColor;
      // Add some random vertical offset for each character
      for (let i = 0; i < this.captchaText.length; i++) {
        const char = this.captchaText[i];
        const offsetY = (Math.random() - 0.5) * 8;
        ctx.save();
        ctx.translate((i - this.captchaText.length / 2 + 0.5) * this.fontSize * 0.8, offsetY);
        ctx.rotate((Math.random() - 0.5) * 0.4);
        ctx.fillText(char, 0, 0);
        ctx.restore();
      }
      ctx.restore();
    },
    regenerate() {
      this.captchaText = this.generateText();
      this.noiseLines = this.generateNoise();
      this.$emit('update', this.captchaText);
      this.$nextTick(this.drawCaptcha);
    },
  },
  mounted() {
    this.regenerate();
  },
  watch: {
    captchaText() {
      this.$nextTick(this.drawCaptcha);
    },
    noiseLines() {
      this.$nextTick(this.drawCaptcha);
    },
  },
  mounted() {
    this.regenerate();
  },
};
</script>

<style scoped>
.captcha-container {
  display: flex;
  align-items: center;
  gap: 8px;
}
svg {
  border: 1px solid #ccc;
  background: #f9f9f9;
  border-radius: 4px;
}
button {
  background: none;
  border: none;
  cursor: pointer;
  font-size: 18px;
}
</style>
